import { AnyAction } from 'redux'

import { IDENTIFY } from '../constants'
import instrumentAction from '../instrumentAction'
import { formatAuthResponse } from '~/redux-modules/auth'

export interface TrackIdentifyData {
    userId: number
    isImpersonating: boolean
    trueUserId: number
    traits: Pick<
        ReturnType<typeof formatAuthResponse>,
        | 'email'
        | 'firstName'
        | 'id'
        | 'isAdmin'
        | 'isVendor'
        | 'lastName'
        | 'munchkinHash'
        | 'name'
        | 'postalCode'
        | 'flags'
        | 'createdAt'
        | 'businessAccountMembership'
        | 'teams'
    >
}

// https://github.com/rangle/redux-segment#identify
export function trackIdentify(
    action: AnyAction,
    userId: number,
    {
        email,
        firstName,
        id,
        isAdmin,
        isImpersonating,
        isVendor,
        lastName,
        munchkinHash,
        name,
        postalCode,
        flags,
        createdAt,
        businessAccountMembership,
        teams,
    }: ReturnType<typeof formatAuthResponse>,
) {
    const data: TrackIdentifyData = {
        userId,
        isImpersonating,
        trueUserId: userId,
        traits: {
            email,
            firstName,
            id,
            isAdmin,
            isVendor,
            lastName,
            munchkinHash,
            name,
            postalCode,
            flags,
            createdAt,
            businessAccountMembership,
            teams,
        },
    }

    return instrumentAction(action, IDENTIFY, data)
}
